// Has reporting platform chrome extension installed
export const hasReportingPlatformChromeExtension = () => {
  try {
    return localStorage.getItem('sandbox-link') === 'true';
  } catch (e) {
    return false;
  }
};